// extracted by mini-css-extract-plugin
export default {"country-select":"country-select","countrySelect":"country-select","select":"select","selected":"selected","options":"options","option":"option"};